import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import FooterOne from '../common/footer/FooterOne';
import SEO from '../common/SEO';

const Employment2 = () => {
    return (
        <>
            <SEO title="Employment2 - Skills Needed" />
            <main className="main-wrapper">
                <Header />

                {/* Centered Content */}
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: '2rem', marginTop: '80px' }}>
                    <div className="text-center" style={{ maxWidth: '800px', width: '100%' }}>

                        {/* Header */}
                        <h1 className="mb-4 fw-bold" style={{ fontSize: '2.5rem', color: 'var(--color-heading)' }}>
                            Skills Needed At East Coast Coders LLC
                        </h1>

                        {/* Content - New Card Layout Variations */}
                        <div className="mb-5">

                            {/* Card 1: Gradient Shadow Card */}
                            <div className="mb-4 p-4" style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '20px',
                                boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                                color: 'white',
                                transform: 'translateY(0)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-5px)';
                                e.target.style.boxShadow = '0 20px 40px rgba(102, 126, 234, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.3)';
                            }}>
                                <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '12px', color: '#fff' }}>
                                    🗄️ Database Administrator
                                </h3>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', margin: 0, opacity: 0.95 }}>
                                    SQL Server • SQL Guru • Backup Support • Moving database skills • Performance tuning • SQL diagnostics • ETL skills to support updating tables to correct data problems • SQL Server Security
                                </p>
                            </div>

                            {/* Card 2: Modern Flat Card with Left Border */}
                            <div className="mb-4 p-4" style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '15px',
                                borderLeft: '6px solid #28a745',
                                boxShadow: '0 5px 25px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                border: '1px solid #f0f0f0'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.boxShadow = '0 8px 35px rgba(40, 167, 69, 0.2)';
                                e.target.style.borderLeftColor = '#20c997';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.boxShadow = '0 5px 25px rgba(0,0,0,0.08)';
                                e.target.style.borderLeftColor = '#28a745';
                            }}>
                                <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '12px', color: '#28a745' }}>
                                    🖥️ Windows Server Specialist
                                </h3>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', margin: 0, color: '#555' }}>
                                    Windows Server Activation Issues • RDS CALs (Remote Desktop Services Client Access Licenses) support • regedit.exe skills • Windows Versioning Skills for migration support • Security Skills • Roles and permission understanding
                                </p>
                            </div>

                            {/* Card 3: Outlined Card with Icon */}
                            <div className="mb-4 p-4" style={{
                                backgroundColor: 'transparent',
                                borderRadius: '15px',
                                border: '2px solid #fd7e14',
                                transition: 'all 0.3s ease',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#fd7e14';
                                e.target.style.color = 'white';
                                e.target.querySelector('h3').style.color = 'white';
                                e.target.querySelector('p').style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = 'inherit';
                                e.target.querySelector('h3').style.color = '#fd7e14';
                                e.target.querySelector('p').style.color = '#555';
                            }}>
                                <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '12px', color: '#fd7e14', transition: 'color 0.3s ease' }}>
                                    🔧 Desktop Support Engineer
                                </h3>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', margin: 0, color: '#555', transition: 'color 0.3s ease' }}>
                                    Troubleshoot VPN access to cloud server with printing locally support • OpenVPN skills • Network knowledge to troubleshoot firewalls and various routers • Familiarity with AI-assisted diagnostic and monitoring tools
                                </p>
                            </div>

                            {/* Additional Layout Option: Grid Cards */}
                            <div style={{ marginTop: '40px' }}>
                                <h4 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>Alternative: Grid Layout</h4>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                    gap: '20px',
                                    marginBottom: '30px'
                                }}>
                                    {/* Mini Card 1 */}
                                    <div style={{
                                        background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
                                        padding: '20px',
                                        borderRadius: '12px',
                                        color: 'white',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 15px rgba(238, 90, 36, 0.3)'
                                    }}>
                                        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>💾</div>
                                        <h5 style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Database</h5>
                                        <small style={{ opacity: 0.9 }}>SQL Server Expert</small>
                                    </div>

                                    {/* Mini Card 2 */}
                                    <div style={{
                                        background: 'linear-gradient(45deg, #4834d4, #686de0)',
                                        padding: '20px',
                                        borderRadius: '12px',
                                        color: 'white',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 15px rgba(72, 52, 212, 0.3)'
                                    }}>
                                        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>🖥️</div>
                                        <h5 style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Windows Server</h5>
                                        <small style={{ opacity: 0.9 }}>System Administration</small>
                                    </div>

                                    {/* Mini Card 3 */}
                                    <div style={{
                                        background: 'linear-gradient(45deg, #00d2d3, #54a0ff)',
                                        padding: '20px',
                                        borderRadius: '12px',
                                        color: 'white',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 15px rgba(0, 210, 211, 0.3)'
                                    }}>
                                        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>🔧</div>
                                        <h5 style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>Desktop Support</h5>
                                        <small style={{ opacity: 0.9 }}>Network & VPN</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Button */}
                        <div>
                            <Link
                                to="/"
                                className="axil-btn btn-fill-primary"
                                style={{
                                    padding: '15px 30px',
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                                onClick={() => {
                                    // Small delay to allow navigation to complete, then scroll to about section
                                    setTimeout(() => {
                                        const aboutSection = document.querySelector('.section.section-padding-equal.bg-color-light');
                                        if (aboutSection) {
                                            aboutSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }, 200);
                                }}
                            >
                                Contact Us
                            </Link>
                        </div>

                    </div>
                </div>

            </main>
        </>
    );
};

export default Employment2;